import Vue from 'vue';
import VueRouter from 'vue-router';
import { routesData } from '../../dashboard-config/routes-config.js';
import { generateNestedRoutes } from '../utils/custom-components-functions.js';

Vue.use(VueRouter);

//get sub page components
let flattenedSubRoutes = [];
routesData.forEach(route => {
  if (route.subRoutes) {
    flattenedSubRoutes = generateNestedRoutes(route.subRoutes, flattenedSubRoutes);
  }
});

//add subpages to routes data in flattened array for vue router
const allRoutes = [...routesData, ...flattenedSubRoutes];

const routes = allRoutes.map(route => {
  return {
    path: route.path,
    name: route.name,
    component: route.component,
    meta: {
      roles: route.roles
    }
  }
});


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
